import { Helmet } from "react-helmet";
import { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DataContext } from "../../AppLayout";
import CapitalFirstLatter from "../../utils/capitalFirst";
import "./style.scss";

function CategoryPage() {
  const navigate = useNavigate();
  const { setLoading, setActiveIndex, setVariant } = useContext(DataContext);
  const { category } = useParams();
  let categoryName = category;
  const [mediaFolder, setMediaFolder] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [categoryPhrase, setCategoryPhrase] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [filters, setFilters] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");

  useEffect(() => {
    getDataFromApi();
  }, []);

  const getDataFromApi = async () => {
    setActiveIndex(1);
    setVariant(false);
    let api = "/database/category.json";
    let res = await fetch(api, { method: "GET" });
    let data = await res.json();
    let Categories = data["Categories"];

    Categories.forEach((item) => {
      let label = String(item["category_name"]).toLowerCase();
      let condition = String(category).replaceAll("+", " ");
      if (condition == label) {
        let keywords = item.data.map(({ title }) => {
          return title;
        });
        setFilters(["All", ...(item["filter"] || [])]);
        setKeywords(keywords);
        setCategoryList(item["data"]);
        setCategoryPhrase(item["text"]);
        let mf = item["media_folder"];
        setMediaFolder(mf);
        setBannerImage(mf + item["banner"]);
      }
    });

    setLoading(false);
  };

  return (
    <div className="category_page">
      <Helmet>
        <title>
          {CapitalFirstLatter(categoryName.replaceAll("+", " "))} | N-Labs
        </title>
        <meta name="keywords" content={"N-Labs, " + keywords.join(", ")} />
        <meta
          name="description"
          content={"Full range of N-Labs " + categoryName.replaceAll("+", " ")}
        />
      </Helmet>
      <div>
        <div className="banner">
          <img alt={categoryName.replaceAll("+", " ")} src={bannerImage} />

          <div className="text">
            <h1>{categoryName.replaceAll("+", " ")}</h1>
            <div className="vspacer2" />
            <p>{categoryPhrase}</p>
          </div>
        </div>

        <div className="container main-margin" style={{ paddingTop: 0 }}>
          {filters.length > 1 && (
            <div className="filter">
              <div>Filter:</div>
              {filters.map((name) => {
                let isActive = name === selectedFilter;
                return (
                  <div
                    key={"filter-item-" + name}
                    onClick={() => setSelectedFilter(name)}
                    className={isActive ? "filter-item active" : "filter-item"}
                  >
                    {name}
                  </div>
                );
              })}
            </div>
          )}
          <div className="product-list">
            {categoryList
              .filter(({ filter }) => {
                if (selectedFilter === "All") return true;
                else {
                  return filter === selectedFilter;
                }
              })
              .map(({ banner, title, sub_title }, index) => {
                let flag = index % 2 == 0;
                let imgUrl = mediaFolder + banner;
                let updated_title = String(title)
                  .replaceAll(" ", "+")
                  .toLowerCase();
                let url = `/products/${category}/${updated_title}`;

                return (
                  <div
                    key={"category_" + index}
                    className="fixWithGrid col2"
                    onClick={() => navigate(url)}
                  >
                    <div>
                      <img alt={title} src={imgUrl} />
                    </div>
                    <div className={flag ? "order-1" : ""}>
                      <h1 >{title}</h1>
                      <h3 className="text-normal">{sub_title}</h3>
                      <div className="vspacer3" />
                      <button>Learn More</button>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryPage;
